import { provideServerRendering } from '@angular/ssr';
import {
  mergeApplicationConfig,
  ApplicationConfig,
  importProvidersFrom,
  PLATFORM_ID,
} from '@angular/core';
import { appConfig } from './app.config';
//import { XhrFactory } from '@angular/common';
//import xhr2 from 'xhr2';
import { TranslateService } from '@ngx-translate/core';
import { APIKEY, ASSETSFOLDER } from '../../../src-server/tokens';
import { translateServerLoaderFactory } from '../shared/loaders/translate-server.loader';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { EnvironmentService } from '../../environments/environment.service';
import { Store } from '@ngrx/store';
import { LogService } from '../core/log/log.service';
import { CallService } from '../core/call-service/browser/call.service';

/*export function callServiceFactory(
  http: HttpClient,
  environmentService: EnvironmentService,
  store: Store,
  logService: LogService,
  PLATFORM_ID,
  APIKEY,
  //state: TransferState,
  translate: TranslateService
) {
  return new CallService(
    http,
    environmentService,
    store,
    logService,
    PLATFORM_ID,
    APIKEY,
    //state,
    translate
  );
}
*/
const clientConfig: ApplicationConfig = {
  providers: [
    {
      provide: APIKEY,
      useValue: '',
    },

    /*{
      provide: CallService,
      useFactory: callServiceFactory,
      deps: [HttpClient, EnvironmentService, Store, LogService, PLATFORM_ID, APIKEY, TranslateService],
    },*/
  ],
};

export const mergedConfig = mergeApplicationConfig(appConfig, clientConfig);
